module.exports = __webpack_public_path__ + "static/media/Plants.e2b65bd3.gif";